<template>
    <div class="no-results d-flex justify-content-start align-items-center">
        <div>
            <svg class="no-results-icon">
                <use xlink:href="#___icon___search-lg-blue"></use>
            </svg>
        </div>
        <div class="no-results-text">
            <div class="no-results-title-text"> {{ content.flight_no_matches }}</div>
            <div class="no-results-cta"> {{ content.flight_no_results }}</div>
        </div>
    </div>
</template>

<script setup lang="ts">
const content = window.content
</script>

<style scoped>
.no-results {
    background-color: var(--blue-100);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    gap: 10px;
    border-radius: 8px;
    height: 62px;
    padding: 10px 20px;
}

.no-results-title-text {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: var(--blue-800);
}

.no-results-cta {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: var(--blue-800);
}

.no-results-icon {
    width: 32px;
    height: 32px;
}
</style>